import request from '@/utils/request'

const inventoryApi = {
  trade_inventory_list: '/trade/inventory/',
  trade_inventory_create: '/trade/inventory/',
  trade_inventory_update: '/trade/inventory/',
  trade_inventory_delete: '/trade/inventory/',
  trade_inventory_to_jd: '/trade/inventory_to_jd/',
  trade_inventory_archived: '/trade/inventory_archived/',
  trade_inventory_total: '/trade/inventory/total/',
  trade_inventory_report_form: '/trade/inventory/report_form/',
  trade_project_inventory_list: '/trade/project_inventory/'
}

/**
 * 列表
 */
export function project_inventory_list (parameter) {
  return request({
    url: inventoryApi.trade_project_inventory_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 90000,
    params: parameter
  })
}

/**
 * 列表
 */
export function inventory_list (parameter) {
  return request({
    url: inventoryApi.trade_inventory_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function inventory_create (parameter) {
  return request({
    url: inventoryApi.trade_inventory_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function inventory_update (parameter, inventory_id) {
  return request({
    url: inventoryApi.trade_inventory_update + inventory_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function inventory_delete (inventory_id) {
  return request({
    url: inventoryApi.trade_inventory_delete + inventory_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function inventory_archived (parameter) {
  return request({
    url: inventoryApi.trade_inventory_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 修改
 */
export function inventory_to_jd (parameter) {
  return request({
    url: inventoryApi.trade_inventory_to_jd,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    timeout: 60000,
    data: parameter
  })
}

/**
 * 出入库总量
 */
export function inventory_total (parameter) {
  return request({
    url: inventoryApi.trade_inventory_total,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 列表
 */
export function trade_inventory_report_form (parameter) {
  return request({
    url: inventoryApi.trade_inventory_report_form,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
